import { render, staticRenderFns } from "./TransactionConfigDetailEdit.vue?vue&type=template&id=1f10f914&scoped=true&"
import script from "./TransactionConfigDetailEdit.vue?vue&type=script&lang=js&"
export * from "./TransactionConfigDetailEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f10f914",
  null
  
)

export default component.exports